import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_indicadores_use_case";

import { QualidadeIndicadores } from "../../models/qualidade_indicadores";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

export class GetAllIndicadoresUseCase
  extends BasePaginatedUseCase<QualidadeIndicadores>
  implements IGetIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllIndicadores(): Promise<QualidadeIndicadores> {

    const response = await this.repository.getAllIndicadores();
    return response;
  }
}
